import keycodes from './keycodes';

const isAnyKey = (key, keys) => keys.includes(key);

export default function isEnterOrSpace(key) {
  return isAnyKey(key, [keycodes.ENTER, keycodes.SPACE]);
}
